import type { Column } from "@tanstack/react-table";
import type { DocumentRowFragment } from "../client/generated";
import { useTranslation } from "react-i18next";
import { DocumentTableHeader } from "./DocumentTableHeader";

type Props = {
  column: Column<DocumentRowFragment, string>;
};

export function DocumentExtensionTableHeader({ column }: Props) {
  const { t } = useTranslation();

  return (
    <DocumentTableHeader
      column={column}
      label={t("DocumentExtensionTableHeader.label")}
    />
  );
}
